/*
 * reducer.js 05.12.2017
 *
 * (c) 2017 ergovia GmbH
 */
import {combineReducers} from 'redux';
import authentication from './authentication';
import sort from './sort';
import participant from './participant';
import participantList from './participantList';
import filter from './filter';
import imprint_dialog from './imprint_dialog';
import survey from './survey';

export default combineReducers({ authentication, sort, participant, participantList, filter, imprint_dialog, survey });



// WEBPACK FOOTER //
// ./src/de/ergovia/reducers/reducer.js